import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from '@all-manager/design-system-v2';
import { CategoryTotal } from '../../utils/expenseStats';
import { formatAmount, formatShare } from '../../utils/formatAmount';

type Props = {
  'aria-label': string;
  totals: CategoryTotal[];
};

export default function CategoryTotalsTable(props: Props) {
  const grandTotal = props.totals.reduce((sum, item) => sum + item.total, 0);

  return (
    <Table size="small" aria-label={props['aria-label']}>
      <TableHead>
        <TableRow>
          <TableCell>Catégorie</TableCell>
          <TableCell align="right">Montant</TableCell>
          <TableCell align="right">Part</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.totals.map((item) => (
          <TableRow key={item.categoryId}>
            <TableCell scope="row">{item.name}</TableCell>
            <TableCell align="right">
              <Typography variant="body1Emphasis">{formatAmount(item.total)}</Typography>
            </TableCell>
            <TableCell align="right">{formatShare(item.share)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableCell scope="row">Total</TableCell>
          <TableCell align="right">
            <Typography variant="body1Emphasis">{formatAmount(grandTotal)}</Typography>
          </TableCell>
          <TableCell />
        </TableRow>
      </TableFooter>
    </Table>
  );
}
